<template>
  <div class="serve-container">
    <h2 class="title">{{ $t('serve.title') }}</h2>
    <div class="server-setting-container">
      <div class="form-group">
        <label class="label">{{ $t('serve.current') }}</label>
        <input class="input" type="text" disabled :value="currentvalue" />
      </div>
      <div class="test-link">
        <p v-if="connectMessage" :style="{ color: connectMessageColor }">{{ connectMessage }}</p>
      </div>
      <div class="form-group">
        <label class="label">{{ $t('serve.select') }}</label>
        <input class="input" type="text" :placeholder="$t('serve.placeholder')" @blur="onServiceBlur" />
      </div>
      <div class="btn-group">
        <button class="btn btn-cancel" @click="back">{{ $t('serve.back') }}</button>
        <button class="btn btn-confirm" @click="onConfirm">{{ $t('btn.confirm') }}</button>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { ref, onMounted, watch, nextTick } from 'vue';
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { request } from 'd3components/src/utils/request';
import { getKeyStr ,removeKey, setKey, setKeyJsonStr ,getKeyJson,updateKeyJson,getsubKey, removeKeys} from 'd3components/src/utils/localStorage';

import { toast } from 'd3components/src/utils/tools';

export default {
  emits: ['current-change'],
  setup(_, { emit }) {
    const router = useRouter();
    const { t } = useI18n();
    const currentvalue = ref('');
    const connectMessage = ref('');
    const connectMessageColor = ref('#4caf50');

    const buttonColor = ref({ backgroundColor: '' });

    const host = ref<Record<string, any>>({});
    const onServiceBlur = (e) => {
      const value = (e.target?.value || '').trim();
      if (value) {
        console.log('输出值为', value);
        // 在这里调用get_server-info接口传参给updateinfo接口，https://www.d3inf.com/iam/get_server_info
        Promise.race([
          request.post({
            url: 'https://www.d3inf.com/iam/get_server_info',
            data: { host: value },
          }),
          new Promise((_, reject) => setTimeout(() => reject(t('serve.timeoutRetry')), 5000)),
        ])
          .then(async (res) => {
            if (res.code === 0) {
              host.value = res.value;
              currentvalue.value = res.value.host;
              await toast(t('serve.fetchSuccess'), 1)
            }
          })
          .catch((err) => {
            console.log('err', err);
            if (err === t('serve.timeoutRetry')) {
              toast(err, 3)
              return
            }
          });
      } else {
        toast(t('serve.pleaseinput'), 2);
      }
    };
    const onConfirm = async () => {
      if (!host.value?.host) {
        toast(t('serve.pleaseinput'), 2);
        return;
      }
      if (host.value.host === currentvalue.value) {
        try {
          updateKeyJson('mobile', 'server_info', host.value);
          toast(t('serve.setSuccess'), 1);
          await router.push('/login');
        } catch (error) {
          console.error('写入 server_info 失败', error);
          toast(error, 3);
        }
      }
    };
    const back = () => {
      router.back();
    };
    let hasInitialized = false;
    onMounted(() => {
      const savedServer = getsubKey('mobile', 'server_info');
      currentvalue.value = (savedServer && savedServer.host) || import.meta.env.VITE_BASE_API || t('serve.notset');
      nextTick(() => {
        hasInitialized = true;
      });
    });
    watch(currentvalue, (newValue, oldValue) => {
      if (!hasInitialized) {
        return;
      }
      if (newValue !== oldValue || newValue.startsWith('http')) {
        const payload = { newValue, oldValue };
        emit('current-change', payload);
        console.log('current-change payload', payload);
        const base = host.value.iam ? host.value.iam : import.meta.env.VITE_IAM;
        connectMessage.value = '';
        connectMessageColor.value = '#4caf50';
        Promise.race([
          request.post({
            url: newValue + base + 'get_server_info',
          }),
          new Promise((_, reject) => setTimeout(() => reject(t('serve.timeout')), 5000)),
        ])
          .then(async (res) => {
            console.log('res', res);
            connectMessage.value = t('serve.testSuccess');

            connectMessageColor.value = '#4caf50';
          })
          .catch((err) => {
            console.error('get_server_info error', err);
            const msg = typeof err === 'string' ? err : err?.message || t('serve.requestFailedCheckAddress');
            toast(msg, 3);
            toast(t('serve.addressIncorrect'), 3);
            connectMessage.value = t('serve.testFail');

            connectMessageColor.value = '#f44336';
          });
      } else {
        console.log('不是 http/https 开头:', newValue);
        toast(t('serve.invalidAddressFormat'), 3);
        connectMessage.value = t('serve.testFail');
        connectMessageColor.value = '#f44336';
      }
    });
    return {
      currentvalue,
      back,
      onServiceBlur,
      onConfirm,
      buttonColor,
      connectMessage,
      connectMessageColor,
    };
  },
};
</script>
<style lang="scss" scoped>
.serve-container {
  height: 100%;
  // background-color: #f5f5f5;
  background-color: var(--app-bg);
}

.server-setting-container {
  width: 80%;
  height: 50%;
  margin: 15% auto;
  padding: 40px 50px;
  // background: white;
  background: var(--app-bg);
  border-radius: 18px;
  // box-shadow: 0 8px 25px rgba(0, 0, 0, 0.07);
  box-sizing: border-box;
  border: 10px  solid var(--app-text);
}

.title {
  text-align: center;
  font-size: 40px;
  font-weight: 600;
  padding-top: 25%;
  color: var(--app-text);
}

.form-group {
  margin-bottom: 28px;
}

.label {
  display: block;
  font-size: 28px;
  // color: #202020;
  color:var(--app-text);
  margin-bottom: 8px;
}

.input {
  width: 90%;
  height: 80px;
  padding: 0 12px;
  border: 1px solid #dcdfe6;
  border-radius: 8px;
  outline: none;
  transition: all 0.2s;
  font-size: 28px;
  //   position: relative;
  //   left: 10%;
}

.input:focus {
  border-color: #409eff;
  box-shadow: 0 0 5px rgba(64, 158, 255, 0.4);
}

.input[disabled] {
  // background: #f5f7fa;
  background: var(--app-text);
  cursor: not-allowed;
}

.input[placeholder] {
  font-size: 18px;
  background: var(--app-text);
}

.btn-group {
  display: flex;
  justify-content: space-between;
  margin-top: 60%;
}

.btn {
  width: 150px;
  line-height: 50px;
  border-radius: 8px;
  font-size: 28px;
  cursor: pointer;
  border: none;
  transition: 0.2s;
}

.btn-cancel {
  background: #f2f3f5;
  color: #666;
}

.btn-cancel:hover {
  background: #e5e6e7;
}

.btn-confirm {
  background: #0e61b4;
  color: white;
}

.btn-confirm:hover {
  background: #66b1ff;
}
.test-link{
  margin:  28px 0 28px  0;
  display: flex;
  justify-content: left;
}
.test-button{
  width: auto;
  height: 50px;
  border: none;
}
</style>
